import WizardModalTemplate, { WizardStep } from 'v2/components/WizardModal/WizardModalTemplate';
import AcceptLegalDocumentsDPAStep from './modal/AcceptLegalDocumentsDPAStep';
import AcceptLegalDocumentsSLAStep from './modal/AcceptLegalDocumentsSLAStep';
import ChooseProviderStep from './modal/ChooseProviderStep';

interface LicensePortalWizardProps {
  initialStep?: number;
}

const LicensePortalWizard: React.FC<LicensePortalWizardProps> = ({ initialStep = 0 }) => {
  const steps: WizardStep[] = [
    { label: 'Accept SLA Legal Documents' },
    { label: 'Accept DPA Legal Documents' },
    { label: 'Choose Provider' }
  ];

  return (
    <WizardModalTemplate title="Welcome to ATLAS" steps={steps} initialStep={initialStep} hideCloseButton>
      <AcceptLegalDocumentsSLAStep />
      <AcceptLegalDocumentsDPAStep />
      <ChooseProviderStep />
    </WizardModalTemplate>
  );
};

export default LicensePortalWizard;
